import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';

import { useQueryObject } from '@interlayer/js/app/hooks/query/useQueryObject';

export const useSetQuery = () => {
    const history = useHistory();
    const queryParams = useQueryObject();

    return useCallback((params, isCombineExisting) => {
        history.replace({
            search: `?${new URLSearchParams(isCombineExisting
                ? { ...queryParams, ...params }
                : params
            ).toString()}`
        });
    }, [history, queryParams]);
};
